export function formatSelectedServices(selectedServices) {
	if (!selectedServices) return '';

	let result = '';

	for (const [key, service] of Object.entries(selectedServices)) {
		if (!service?.isChecked) continue;

		// Capitalize the name (fallback to the ID)
		const label = service.name || key;
		result += `- ${label}\n`;

		// Handle sub-packages
		if (service.subPackages) {
			for (const sub of Object.values(service.subPackages)) {
				if (sub?.isChecked || typeof sub?.isChecked === 'undefined') {
					result += `   • ${sub.name}\n`;
				}
			}
		}
	}

	return result.trim();
}
